import { DISABLE_TABLE_NUMBER_INPUT_CONTROLS_SX } from 'components/underwriting/constants';

export const EXPENSE_HISTORY_TABLE_BASE_SX = {
  '& .total-row': {
    backgroundColor: '#f5f5f5',
    fontWeight: 'bold',
    borderTop: '1px solid #ddd',
  },
  '& .MuiDataGrid-cell': {
    borderRight: '1px solid #f0f0f0',
  },
  '& .disabled-cell': {
    backgroundColor: 'rgb(245, 245, 245)',
    color: '#666',
    fontWeight: 'normal',
  },
  ...DISABLE_TABLE_NUMBER_INPUT_CONTROLS_SX,
};
